<template>
  <div class="wy-list-page">

    <floating-button :route="{ name: 'GasStation' }"/>
    <CCard>
      <CCardBody>

        <CAlert color="danger" v-if="!_.isEmpty(error)" closeButton @update:show="error = ''">
          {{ error }}
        </CAlert>

        <CAlert color="success text-center" v-if="!_.isEmpty(message)">
          {{ message }}
        </CAlert>

        <div v-if="!loaded">
          <inline-loader/>
        </div>

        <div v-if="loaded">
          <div class="wy-search-input-container" v-if="_.isEmpty(message)">
            <input
                class="form-control full-width"
                :placeholder="$t('type_here_to_search')"
                type="text"
                v-model="search"
                @input="runSearch"
                @keydown.esc="clearSearch"
            />
            <button class="wy-clear-button" @click="clearSearch" v-if="search !== ''">
              <span class="wy-icon-clear-input"></span>
            </button>
          </div>

          <CAlert color="success text-center" class="mt-3" v-if="noSearchResult">
            {{ $t('no_result_found') }}
          </CAlert>

          <div v-if="!_.isEmpty(gasStations)">
            <div class="table-responsive-md">
              <table class="table table-hover wy-list-table">
                <thead>
                <tr>
                  <th style="width: 50px;">#</th>
                  <th>{{ $t('station_name') }}</th>
                  <th>{{ $t('address') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(gasStation, gasStationIndex) in gasStations"
                    :key="`gasStation_${gasStationIndex}`"
                    :class="{ 'wy-blocked-table-row': gasStation.blocked }">
                  <td>{{ gasStation.id }}</td>
                  <td>
                    <strong>{{ gasStation.name }}</strong>
                    <div class="text-muted no-wrap">
                      {{ $t('number_of_tanks') }}: {{ gasStation.tanks_count }}
                    </div>
                    <div class="text-muted no-wrap">
                      {{ $t('number_of_pumps') }}: {{ gasStation.pumps_count }}
                    </div>
                    <div class="text-muted no-wrap">
                      {{ $t('number_of_workers') }}: {{ gasStation.workers_count }}
                    </div>
                  </td>
                  <td>
                    <strong>{{ gasStation.city }}</strong>
                    <div class="text-muted">{{ gasStation.street }}</div>
                    <div>{{ gasStation.district }}</div>
                  </td>
                  <td style="width: 120px; white-space: nowrap;">
                    <div class="row">
                      <div class="col">
                        <CButton color="wy-action-button p-0" @click="toggleBlock(gasStationIndex)" :class="{ 'text-red': gasStation.blocked }"><i class="wy-icon-ban p-0"></i></CButton>
                      </div>
                      <div class="col">
                        <CButton color="wy-action-button p-0" @click="editGasStation(gasStationIndex)"><i class="wy-icon-pencil p-0"></i></CButton>
                      </div>
                      <div class="col">
                        <CButton color="wy-action-button p-0" @click="deleteGasStation(gasStationIndex)"><i class="wy-icon-delete p-0"></i></CButton>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="row wy-pagination-info">
              <div class="col">
                {{ $t('from') }} {{ from }}
                {{ $t('to') }} {{ to }}
              </div>
              <div class="col text-right">
                <strong>{{ $t('total') }}: {{ total }}</strong>
              </div>
            </div>

            <CPagination
                align="center"
                :pages="lastPage"
                :active-page.sync="currentPage"
            />
          </div>
        </div>

      </CCardBody>
    </CCard>

  </div>
</template>

<script>
import { gasStations, deleteGasStation, unBlockGasStation, blockGasStation } from "../../../api/gasStation";
import FloatingButton from "../../components/FloatingButton";
import InlineLoader from "../../components/InlineLoader";
import _ from "lodash";

export default {
  name: 'GasStationsList',
  components: {
    FloatingButton,
    InlineLoader,
  },
  data() {
    return {
      currentPage: 0,
      activePage: 0,
      firstPage: 0,
      lastPage: 0,
      perPage: 0,
      total: 0,
      from: 0,
      to: 0,
      message: '',
      error: '',
      search: '',
      loaded: false,
      noSearchResult: false,
      //
      gasStations: [],
    };
  },
  watch: {
    currentPage(newValue) {
      this.getGasStations();
      this.$router.replace({name: this.$route.name, params: this.$route.params, query: {page: newValue}});
    },
    '$route.query.page': function (page) {
      if (this._.isUndefined(page)) {
        page = 1;
      }
      this.error = '';
      this.currentPage = page;
    }
  },
  mounted() {
    this.currentPage = Number(this.$route.query.page) || 1;
    this.getGasStations();
    this.firstPage = 1;
  },
  methods: {
    getGasStations() {
      this.noSearchResult = false;
      gasStations(this, this.currentPage, this.search, (response) => {
        this.gasStations = response.gas_stations.data;
        this.lastPage = Number(response.gas_stations.last_page);
        this.perPage = Number(response.gas_stations.per_page);
        this.total = Number(response.gas_stations.total);
        this.from = Number(response.gas_stations.from);
        this.to = Number(response.gas_stations.to);
        this.loaded = true;
        if (this._.isEmpty(this.gasStations)) {
          if (!this._.isEmpty(this.search)) {
            this.noSearchResult = true;
          } else {
            this.message = this.$t('empty_list');
          }
        }
        this.$forceUpdate();
      });
    },
    clearSearch() {
      if (this.search !== '') {
        this.search = '';
        this.getGasStations();
      }
    },
    runSearch: _.debounce(function() {
      this.currentPage = 1;
      this.getGasStations();
    }, 500),
    editGasStation(gasStationIndex) {
      this.$router.push({ name: 'GasStation', params: {gas_station_id: this.gasStations[gasStationIndex]['id'] } });
    },
    deleteGasStation(gasStationIndex) {
      this.$store.commit('confirmation', {
        message: this.$t('are_you_sure_that_you_want_to_delete_this_gas_station', { gasStationName: this.gasStations[gasStationIndex].name }),
        onOk: () => {
          this.error = '';
          this.message = '';
          deleteGasStation(this, this.gasStations[gasStationIndex]['id'], (response) => {
            this.$delete(this.gasStations, gasStationIndex);
            this.total -= 1;
            this.message = response.message;
            if (this.total > this.gasStations.length && this.gasStations.length > 0 && this.currentPage !== this.lastPage) {
              this.getGasStations();
            } else if (this.gasStations.length === 0 && this.currentPage > 1) {
              this.currentPage -= 1;
            }
            this.$forceUpdate();
          }, (error) => {
            this.error = error.message;
          });
        }
      })
    },
    toggleBlock(gasStationIndex) {
      if (this.gasStations[gasStationIndex]['blocked']) {
        unBlockGasStation(this, this.gasStations[gasStationIndex]['id'], () => {
          this.gasStations[gasStationIndex]['blocked'] = false;
        }, (error) => {
          this.error = error.message;
        });
      } else {
        blockGasStation(this, this.gasStations[gasStationIndex]['id'], () => {
          this.gasStations[gasStationIndex]['blocked'] = true;
        }, (error) => {
          this.error = error.message;
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wy-list-page {
  .wy-search-input-container::v-deep {
    position: relative;
    input {
      background-color: #F1F1F1;
      [dir=ltr] & {
        padding-right: 40px;
      }

      [dir=rtl] & {
        padding-left: 40px;
      }
    }
    button.wy-clear-button {
      position: absolute;
      background: none;
      border: none;
      top: 8px;
      color: #C41117;
      transition: color 350ms ease;
      [dir=ltr] & {
        right: 5px;
      }

      [dir=rtl] & {
        left: 5px;
      }
      span {
        margin: 0!important;
        font-size: 24px;
      }
      &:focus {
        outline: none;
      }
      &:hover {
        color: #222222;
      }
    }
  }
  .wy-list-table {
    thead {
      th {
        border-top-width: 0;
      }
    }
  }
}
</style>
